export default "__VITE_ASSET__DUc7OtZS__"